import React from 'react';

const SixDotsMenu = (props: { className: any, onClick?: any }) => {
  const { className, onClick } = props;

  const handleOnClick = (e: any) => {

    if (onClick) onClick(true);
  }

  return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" fill="none">
            <g id="drag">
                <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M28 23C28 24.1045 27.1045 25 26 25C24.8954 25 24 24.1045 24 23C24 21.8954 24.8954 21 26 21C27.1045 21 28 21.8954 28 23ZM26 32C27.1045 32 28 31.1046 28 30C28 28.8955 27.1045 28 26 28C24.8954 28 24 28.8955 24 30C24 31.1046 24.8954 32 26 32ZM26 39C27.1045 39 28 38.1045 28 37C28 35.8954 27.1045 35 26 35C24.8954 35 24 35.8954 24 37C24 38.1045 24.8954 39 26 39Z" />
                <path id="Vector_2" fill-rule="evenodd" clip-rule="evenodd" d="M37 23C37 24.1045 36.1045 25 35 25C33.8954 25 33 24.1045 33 23C33 21.8954 33.8954 21 35 21C36.1045 21 37 21.8954 37 23ZM35 32C36.1045 32 37 31.1046 37 30C37 28.8955 36.1045 28 35 28C33.8954 28 33 28.8955 33 30C33 31.1046 33.8954 32 35 32ZM35 39C36.1045 39 37 38.1045 37 37C37 35.8954 36.1045 35 35 35C33.8954 35 33 35.8954 33 37C33 38.1045 33.8954 39 35 39Z" />
            </g>
        </svg>
  );
};
export default SixDotsMenu;